"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRobotsTxt = exports.allowCrawling = void 0;
var crawling_1 = require("./crawling");
Object.defineProperty(exports, "allowCrawling", { enumerable: true, get: function () { return crawling_1.allowCrawling; } });
var robots_1 = require("./robots");
Object.defineProperty(exports, "buildRobotsTxt", { enumerable: true, get: function () { return robots_1.buildRobotsTxt; } });
